import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ContactsResult from './components/contacts-result/index';
import {
	confirmContactResearch,
	contactsAdvancedSearchRequest,
	contactSearchResult,
	contactSearchResultPageNumber,
	contactsPageNumber,
	enteredContactSearchValue,
	isContactsAdvancedSearchDropDown as setIsContactsAdvancedSearchDropDown,
	isContactsSearchAdvancedMode,
	isSearchingContacts,
	isSearchResultsDropDownShown as setIsSearchResultsDropDownShown, resetContactSearchResult
} from '../../../../../actions/contactActions';
import { upperCaseFirstLetter } from '../../../../utils/index';
import SearchBar from '../../../search-bar/index';
import ContactsAdvancedSearch from './components/contacts-advanced-search/index';

const ContactSearch = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const isSearchResultsDropDownShown = useSelector(state => state.contactReducer.isSearchResultsDropDownShown);
	const pageSize = useSelector(state => state.contactReducer.contactSearchResultPageSize);
	const isContactsAdvancedSearchDropDown = useSelector(state => state.contactReducer.isContactsAdvancedSearchDropDown);

	const handleChange = useCallback((e) => {
		const value = e.currentTarget.value;

		dispatch(confirmContactResearch(false));
		dispatch(isContactsSearchAdvancedMode(false));
		dispatch(contactsAdvancedSearchRequest(null));
		dispatch(isSearchingContacts(true));
		dispatch(contactSearchResultPageNumber(1));

		/*if (selectedContacts.length > 0 && enteredSearchValue === "") {
			dispatch(getSharingDetailsPopup([true, "easter_egg"]));
		}*/

		if(!isSearchResultsDropDownShown){
			dispatch(setIsSearchResultsDropDownShown(true));
		}

		dispatch(enteredContactSearchValue(value));

		if(value !== ""){
			dispatch(contactSearchResult(value, pageSize));
		} else {
			dispatch(isSearchingContacts(false));
			dispatch(setIsSearchResultsDropDownShown(false))
			dispatch(resetContactSearchResult());
		}

		if(isContactsAdvancedSearchDropDown){
			dispatch(setIsContactsAdvancedSearchDropDown(false));
		}

	}, [dispatch, isContactsAdvancedSearchDropDown, isSearchResultsDropDownShown, pageSize]);

	const keyPressHandler = useCallback((e) => {
		if (e.which === 13) {
			dispatch(confirmContactResearch(true));
			dispatch(contactsPageNumber(1));
			dispatch(setIsSearchResultsDropDownShown(false));
		}
	}, [dispatch]);

	const contactsAdvancedSearchDropDownHandler = useCallback(() => {
		if(isSearchResultsDropDownShown){
			dispatch(setIsSearchResultsDropDownShown(false));
		}
		dispatch(setIsContactsAdvancedSearchDropDown(!isContactsAdvancedSearchDropDown));
	}, [dispatch, isSearchResultsDropDownShown, isContactsAdvancedSearchDropDown]);

	return (
		<div className="list-of-contacts-header flex-grow-1 mr-4">
			<SearchBar
				id="searchContact"
				className="m-auto"
				label="Search a contact"
				title={t("textSearchContact")}
				srOnly={true}
				onKeyPress={keyPressHandler}
				onChange={handleChange}
				placeholder={upperCaseFirstLetter(t("textSearchContact"))}
				advancedSearchMode={true}
				isAdvancedSearchDropDown={isContactsAdvancedSearchDropDown}
				advancedSearchDropDownHandler={contactsAdvancedSearchDropDownHandler}
				advancedSearchContent={<ContactsAdvancedSearch />}
			/>
			{isSearchResultsDropDownShown && <ContactsResult />}
		</div>
	);
};

export default ContactSearch;
